import { Navigate } from 'react-router-dom';
import { useAuthUser, parseUserRole } from '@ubus/shared';
import { homePathForRole } from '../utils/homePath';

/** Role-aware default landing after `/`. */
export function HomeRedirect() {
  const user = useAuthUser();
  return <Navigate to={homePathForRole(parseUserRole(user))} replace />;
}

export default HomeRedirect;
